import { render, staticRenderFns } from "./zhiyuan.vue?vue&type=template&id=ad6f84c6&scoped=true"
import script from "./zhiyuan.vue?vue&type=script&lang=js"
export * from "./zhiyuan.vue?vue&type=script&lang=js"
import style0 from "./zhiyuan.vue?vue&type=style&index=0&id=ad6f84c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6f84c6",
  null
  
)

export default component.exports